<template>
  <ColourSwatchOptions
    v-if="swatches"
    :items="swatchItems"
    @change="handleListItemClick"
  />
  <ul v-else>
    <form class="form">
      <label
        v-for="value in filteredValues"
        :key="value.id"
        class="field field--checkbox"
      >
        <span class="field__label">
          {{ getFilterValueLabel(value.label) }} ({{ value.count }})
        </span>
        <div class="input input--checkbox">
          <input
            :checked="isFilterSelected(value)"
            type="checkbox"
            class="input__element input__element--checkbox"
            @change="handleListItemClick(value)"
          />
          <span class="input__checkbox"></span>
        </div>
      </label>
    </form>
  </ul>
</template>

<script>
import isEqual from "lodash-es/isEqual";
import { getFilterValueLabel } from "@/helpers/collection";
import ColourSwatchOptions from "@/components/collection/filters/ColourSwatchOptions.vue";

export default {
  name: "ListFilter",
  components: {
    ColourSwatchOptions,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
    swatches: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change"],
  computed: {
    filteredValues() {
      return this.values.filter((value) => value.count > 0);
    },
    swatchItems() {
      return [...this.filteredValues]
        .sort((a, b) =>
          getFilterValueLabel(a.label).localeCompare(
            getFilterValueLabel(b.label)
          )
        )
        .map((value) => ({
          ...value,
          label: getFilterValueLabel(value.label),
          selected: this.isFilterSelected(value),
        }));
    },
  },
  methods: {
    getFilterValueLabel,
    isFilterSelected(value) {
      const valueInput = JSON.parse(value.input);

      const filterKey = Object.keys(valueInput)[0];
      const selectedFilters = JSON.parse(JSON.stringify(this.filters));

      const selectedFiltersHasSelectedFilter = selectedFilters?.some(
        (selectedFilter) => {
          if (isEqual(selectedFilter[filterKey], valueInput[filterKey])) {
            return true;
          }
          return false;
        }
      );

      return selectedFiltersHasSelectedFilter;
    },
    handleListItemClick(value) {
      this.$emit("change", JSON.parse(value.input));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";
</style>
